export default "__VITE_ASSET__CtoB72_u__"